import PropTypes from 'prop-types';

import useSelectionsQuery from 'api/queries/useSelectionsQuery';
import Button from 'honeydew/Button';
import Modal from 'honeydew/Modal';

import { ALCOHOL_SERVICE_FEE } from '../../constants/shop';

function FeeDetailsModal({ closeFeeDetailsModal, feeDetailsModal }) {
    const { data: selections = {} } = useSelectionsQuery();
    const { coldKeeperFee } = selections;

    return (
        <Modal open={feeDetailsModal} onClose={closeFeeDetailsModal}>
            <div className="text-body-md md:px-50 md:py-20">
                <h2 className="text-heading-md mb-20">Fee Details</h2>

                <h3 className="mb-10 font-grotesk-bold">Tax + Shipping</h3>
                <p className="mb-20">
                    Taxes may apply based on your delivery address and types of items purchased and will be specified in
                    your cart during your shopping window, if applicable. Shipping is a flat rate by zip code that
                    starts at $6.99 per order. Shipping fees are subject to change from time to time, and you will be
                    notified of the shipping charges applicable to your Order based on the charges specified in your
                    cart during your shopping window.
                </p>

                {coldKeeperFee > 0 && (
                    <>
                        <h3 className="mb-10">
                            <span className="font-grotesk-bold">Cold Pack Fee</span>
                            <span className="mx-10 text-grey">|</span> ${coldKeeperFee}
                        </h3>
                        <p className="mb-20">
                            Packaging fee may apply to keep items like meat, seafood, and dairy refrigerator-cold in
                            transit. Fee will be waived if $30+ of Cold Pack items are ordered.
                        </p>
                    </>
                )}

                <h3 className="mb-10">
                    <span className="font-grotesk-bold">Alcohol Service Fee</span>
                    <span className="mx-10 text-grey">|</span> ${ALCOHOL_SERVICE_FEE}
                </h3>
                <p className="mb-20">
                    This fee applies to wine orders and covers our operating and delivery expenses, including the
                    additional costs associated with ID verification and compliant delivery of alcohol to your door. Fee
                    will be waived if 6+ bottles are ordered.
                </p>

                <Button type="button" onClick={closeFeeDetailsModal}>
                    Close
                </Button>
            </div>
        </Modal>
    );
}

FeeDetailsModal.propTypes = {
    closeFeeDetailsModal: PropTypes.func.isRequired,
    feeDetailsModal: PropTypes.bool.isRequired,
};

export default FeeDetailsModal;
